import { Reveal } from "@/components/Reveal";
import { EnquiryForm } from "@/components/EnquiryForm";

export const ConsultationCta = () => (
    <section data-testid="home-consultation" className="relative overflow-hidden border-t border-wood/10 bg-sand py-20 lg:py-28">
        <span aria-hidden className="pointer-events-none absolute -right-8 -top-10 select-none font-serif text-[12rem] italic leading-none text-wood/[0.05] lg:text-[20rem]">
            05
        </span>
        <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 sm:px-12 lg:grid-cols-12 lg:gap-16 lg:px-20">
            <Reveal className="lg:col-span-4">
                <div className="flex items-center gap-4">
                    <span className="font-mono text-sm text-terra">05</span>
                    <span className="h-px w-10 bg-terra/50" />
                    <span className="text-xs uppercase tracking-[0.25em] text-timber">Request a Consultation</span>
                </div>
                <h2 className="mt-6 font-serif text-2xl font-normal leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl">
                    Tell Us About Your Space
                </h2>
                <p className="mt-6 text-base font-light leading-relaxed text-mute">
                    Leave your details and we'll call to arrange a first conversation — at your site or
                    at the studio. No commitment, no catalogue.
                </p>
            </Reveal>
            <Reveal delay={0.15} className="lg:col-span-8">
                <EnquiryForm source="home" compact />
            </Reveal>
        </div>
    </section>
);
